<template>
  <div class="book-bread">
    <!-- 面包屑 -->
    <BookSubBread />
  </div>
  <div class="book">
    <BookCategory />
    <div class="book-item">
      <BookItem :books="books" />
    </div>
    <div class="pagination">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total,  prev, pager, next"
        :total="booksCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { findBooks } from "@/api/books";
import BookSubBread from "./compontents/booksub-bread.vue";
import BookCategory from "./compontents/book-category.vue";
import BookItem from "./compontents/book-item.vue";
import { nextTick, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

export default {
  name: "book",
  components: {
    BookCategory,
    BookItem,
    BookSubBread,
  },
  setup() {
    const route = useRoute();
    const books = ref([]);
    //总页数
    const booksCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);
    findBooks({
      maID: route.query.maID,
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        books.value = data.result.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            booksPrice: item.booksPrice,
            salePrice: item.salePrice,
            mainImgs: "/web/" + item.mainImgs[0]?.url,
            booksTitle: item.booksTitle,
            id: item._id,
          };
        });
        if (data.resultLength.length) {
          booksCount.value = data.resultLength[0].totalCount;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        findBooks({
          maID: route.query.maID,
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        })
          .then((data) => {
            (books.value = []),
              nextTick(() => {
                books.value = data.result.map((item) => {
                  return {
                    chID: item.chID,
                    maID: item.maID,
                    coID: item.coID,
                    clID: item.clID,
                    booksPrice: item.booksPrice,
                    salePrice: item.salePrice,
                    mainImgs: "/web/" + item.mainImgs[0]?.url,
                    booksTitle: item.booksTitle,
                    id: item._id,
                  };
                });
                if (data.resultLength.length) {
                  booksCount.value = data.resultLength[0].totalCount;
                }
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    );
    const currentChange = (page) => {
      currentPage.value = page;
      //findLesson(currentPage);
      //console.log(page);
    };
    const changeSize = (size) => {
      pageSize.value = size;
    };
    return {
      books,
      booksCount,
      currentPage,
      pageSize,
      currentChange,
      changeSize,
    };
  },
};
</script>

<style scoped lang="less">
.book-bread {
  background: @shColor;
  margin-bottom: 15px;
}
.book {
  width: 1240px;
  margin: 0 auto;
  .book-item {
    width: 1240px;
    position: relative;
  }
  .pagination {
    display: flex;
    margin-top: 20px;
    font-size: 16px;
    justify-content: center;
  }
}
</style>
